import axios from 'axios'
import * as Config from '../config'
import { data } from 'autoprefixer'
import FormData from 'form-data'
// import fs from 'fs'

const instance = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 1000000,
})

const multiPartInstance = axios.create({
  timeout: 1000000,
})
// add by admin

multiPartInstance.interceptors.request.use(function (config) {
  const token = localStorage.getItem('adminToken')
  config.headers.Authorization = `Bearer ${token}`

  return config
})

instance.interceptors.request.use(function (config) {
  const token = localStorage.getItem('adminToken')
  config.headers.Authorization = `Bearer ${token}`

  return config
})

instance.interceptors.request.use(
  (request) => {
    return request
  },
  (error) => {
    return Promise.reject(error)
  },
)

export const API = {
  commonApi: {
    //upload image
    postImage: (props) =>
      axios.post(`${Config.UPLOAD_IMAGE}?s3_path=${props.path}`, props.data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }),
  },
  settingApi: {
    //visit type
    visitType: () => instance.get(Config.VISIT_TYPE),
    deleteVisitType: (id) => instance.delete(`${Config.VISIT_TYPE}${id}/`),
    updateUserData: (props) => instance.put(`${Config.VISIT_TYPE}${props.id}/`, props.data),
    addVisitType: (data) => instance.post(Config.VISIT_TYPE, data),
    //Banner
    getBanner: () => instance.get(Config.BANNER),
    deleteBanner: (id) => instance.delete(`${Config.BANNER}${id}/`),
    updateBanner: (props) => instance.put(`${Config.BANNER}${props.id}/`, props.data),
    addBanner: (data) => instance.post(Config.BANNER, data),
    //speciality
    speciality: () => instance.get(Config.SPECIALITY),
    deleteSpeciality: (id) => instance.delete(`${Config.SPECIALITY}${id}`),
    updateSpeciality: (props) => instance.put(`${Config.SPECIALITY}${props.id}`, props.data),
    addSpeciality: (data) => instance.post(Config.SPECIALITY, data),
    //education
    education: () => instance.get(Config.EDUCATION),
    deleteEducation: (id) => instance.delete(`${Config.EDUCATION}${id}`),
    updateEducation: (props) => instance.put(`${Config.EDUCATION}${props.id}`, props.data),
    addEducation: (data) => instance.post(Config.EDUCATION, data),
    //specialInterest
    specialInterest: () => instance.get(Config.SPECIAL_INTEREST),
    deleteSpecialInterest: (id) => instance.delete(`${Config.SPECIAL_INTEREST}/${id}`),
    updateSpecialInterest: (props) =>
      instance.put(`${Config.SPECIAL_INTEREST}/${props.id}`, props.data),
    addSpecialInterest: (data) => instance.post(Config.SPECIAL_INTEREST, data),
    //state
    //state: () => instance.get(Config.STATE),
    stateList: (data) => {
      let url = Config.STATE // Adjust this if necessary
      let queryString = ''

      if (data) {
        if (typeof data === 'number' || (typeof data === 'string' && !isNaN(data))) {
          // If data is a numeric ID or string representing a number
          url += `/${data}`
        } else if (typeof data === 'object' && data !== null) {
          // If data is an object, handle pagination and additional parameters
          const { page, pageSize, urlAddOn } = data

          if (page !== undefined && page !== '') {
            queryString += `page=${page}`
          }

          if (pageSize !== undefined && pageSize !== '') {
            if (queryString) {
              queryString += '&'
            }
            queryString += `size=${pageSize}`
          }

          let formattedUrlAddOn = ''
          if (urlAddOn && urlAddOn.trim() !== '') {
            if (queryString) {
              formattedUrlAddOn = `&${urlAddOn.startsWith('&') ? urlAddOn.slice(1) : urlAddOn}`
            } else {
              formattedUrlAddOn = urlAddOn
            }
          }

          queryString += formattedUrlAddOn
        }
      }

      const finalUrl = queryString ? `${url}?${queryString}` : url

      return instance.get(finalUrl)
    },

    deleteState: ({ id }) => instance.delete(`${Config.STATE}${id}`),
    updateState: ({ id, ...data }) => instance.put(`${Config.STATE}${id}`, data),
    addState: (data) => instance.post(Config.STATE, data),

    // Taluk

    talukListApi: (data) => {
      let url = Config.TALUK
      let queryString = ''

      // Check if data is present
      if (data) {
        // Check if data is a number or a string representing a number
        if (typeof data === 'number' || (typeof data === 'string' && !isNaN(data))) {
          // Append the numeric ID to the URL
          url += `${data}`
        } else if (typeof data === 'object' && data !== null) {
          // Destructure data if it's an object
          const { page, pageSize, urlAddOn } = data

          // Add page parameter if it exists and is not empty
          if (page !== undefined && page !== '') {
            queryString += `page=${page}`
          }

          // Add size parameter if it exists and is not empty
          if (pageSize !== undefined && pageSize !== '') {
            if (queryString) {
              queryString += '&' // Append '&' if there's already a query string
            }
            queryString += `size=${pageSize}`
          }

          // Format urlAddOn correctly
          let formattedUrlAddOn = ''
          if (urlAddOn && urlAddOn.trim() !== '') {
            if (queryString) {
              // Ensure urlAddOn starts with '&' if queryString is already present
              formattedUrlAddOn = `&${urlAddOn.startsWith('&') ? urlAddOn.slice(1) : urlAddOn}`
            } else {
              formattedUrlAddOn = urlAddOn
            }
          }

          // Combine queryString with urlAddOn
          queryString += formattedUrlAddOn
        }
      }

      // Construct the final URL with or without query string
      const finalUrl = queryString ? `${url}?${queryString}` : url

      // Make the API call
      return instance.get(finalUrl)
    },

    addTaluk: (data) => instance.post(Config.TALUK, data),
    updateTaluk: ({ id, ...data }) => instance.put(`${Config.TALUK}${id}`, data),
    deleteTaluk: ({ id }) => instance.delete(`${Config.TALUK}${id}`),
    talukDetails: (data) => instance.get(`${Config.TALUK}${data.id}/`),
  },
  authApi: {
    loginApi: ({ data, headers }) => instance.post(Config.LOGIN, data, { headers }),
  },
  providerManagementApi: {
    getSlotTypeList: () => instance.get(Config.SLOT_TYPE_LIST),
    addUserData: (data) => instance.post(`${Config.ADD_USER}?is_added_by_admin=true`, data),
    userListApi: (data) => {
      let last = `page=${data?.page}&size=${data?.pageSize}${data?.urlAddOn || ''}`

      return instance.get(`${Config.USER_LIST}?${last}`)
    },
    deleteUserData: (props) => instance.delete(`${Config.USER_LIST}${props.id}/`),

    //doctor
    addDoctorData: (data) => instance.post(`${Config.DOCTOR_LIST}?is_added_by_admin=true`, data),
    // doctorListApi: () => instance.get(Config.DOCTOR_LIST),
    doctorListApi: (data) => {
      let last = `page=${data?.page}&size=${data?.pageSize}${data?.urlAddOn || ''}`
      return instance.get(`${Config.DOCTOR_LIST}?${last}`)
    },
    updateDoctorData: ({ doctor_id, ...data }) =>
      instance.patch(`${Config.DOCTOR_LIST}${doctor_id}`, data),
    deleteDoctorData: ({ id }) => instance.delete(`${Config.DOCTOR_LIST}${id}`),

    //hospital
    addHospitalData: (data) =>
      instance.post(`${Config.HOSPITAL_LIST}?is_added_by_admin=true`, data),
    // hospitalListApi: () => instance.get(Config.HOSPITAL_LIST),
    hospitalListApi: (data) => {
      let last = `page=${data?.page}&size=${data?.pageSize}${data?.urlAddOn || ''}`
      return instance.get(`${Config.HOSPITAL_LIST}?${last}`)
    },
    updateHospitalData: ({ id, ...data }) => instance.put(`${Config.HOSPITAL_LIST}${id}`, data),
    deleteHospitalData: (props) => instance.delete(`${Config.HOSPITAL_LIST}${props.id}/`),

    addPharmacyData: (data) =>
      instance.post(`${Config.PHARMACY_LIST}?is_added_by_admin=true`, data),
    approvedPharmacyData: ({ id }) => instance.put(`${Config.APPROVED_PHARMACY_BY_ADMIN}${id}/`),
    getPharmacyData: (data) => {
      const { page, pageSize, urlAddOn } = data
      let queryString = ''

      // Add page parameter if it exists and is not empty
      if (page !== undefined && page !== '') {
        queryString += `page=${page}`
      }

      // Add size parameter if it exists and is not empty
      if (pageSize !== undefined && pageSize !== '') {
        if (queryString) {
          queryString += '&' // Append '&' if there's already a query string
        }
        queryString += `size=${pageSize}`
      }

      // Format urlAddOn correctly
      let formattedUrlAddOn = ''
      if (urlAddOn && urlAddOn.trim() !== '') {
        if (queryString) {
          // Ensure urlAddOn starts with '&' if queryString is already present
          formattedUrlAddOn = `&${urlAddOn.startsWith('&') ? urlAddOn.slice(1) : urlAddOn}`
        } else {
          formattedUrlAddOn = urlAddOn
        }
      }

      // Construct the final URL
      const url = `${Config.PHARMACY_LIST}${
        queryString ? '?' + queryString : ''
      }${formattedUrlAddOn}`

      // Make the GET request
      return instance.get(url)
    },
    updatePharmacyData: ({ id, ...data }) => instance.put(`${Config.PHARMACY_LIST}${id}`, data),
    deletePharmacyData: ({ id }) => instance.delete(`${Config.PHARMACY_LIST}${id}/`),

    //scan_center
    // getScanCenterData: (data) => instance.get(Config.SCAN_CENTER_LIST),
    addScanCenterData: (data) =>
      instance.post(`${Config.SCAN_CENTER_LIST}?is_added_by_admin=true`, data),
    getScanCenterData: (data) => {
      let last = `page=${data?.page}&size=${data?.pageSize}${data?.urlAddOn || ''}`
      return instance.get(`${Config.SCAN_CENTER_LIST}?${last}`)
    },
    updateScanCenterData: ({ id, ...data }) =>
      instance.put(`${Config.SCAN_CENTER_LIST}${id}`, data),
    deleteScanCenterData: ({ id }) => instance.delete(`${Config.SCAN_CENTER_LIST}${id}/`),

    //laboratory
    // getLaboratoryData: (data) => instance.get(Config.LABORATORY_LIST),
    getLaboratoryData: (data) => {
      let last = `page=${data?.page}&size=${data?.pageSize}${data?.urlAddOn || ''}`
      return instance.get(`${Config.LABORATORY_LIST}?${last}`)
    },
    addLaboratoryData: (data) =>
      instance.post(`${Config.LABORATORY_LIST}?is_added_by_admin=true`, data),
    updateLaboratoryData: ({ id, ...data }) => instance.put(`${Config.LABORATORY_LIST}${id}`, data),
    deleteLaboratoryData: ({ id }) => instance.delete(`${Config.LABORATORY_LIST}${id}/`),

    //ambulance
    getAmbulanceData: (data) => {
      const { page, pageSize, urlAddOn = '' } = data
      let queryParams = []
      if (page !== undefined) {
        queryParams.push(`page=${page}`)
      }
      if (pageSize !== undefined) {
        queryParams.push(`size=${pageSize}`)
      }
      if (urlAddOn) {
        queryParams.push(urlAddOn)
      }
      const queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : ''
      const url = `${Config.AMBULANCE_LIST}${queryString}`
      return instance.get(url)
    },
    addAmbulanceData: (data) =>
      instance.post(`${Config.AMBULANCE_LIST}?is_added_by_admin=true`, data),
    updateAmbulanceData: ({ id, ...data }) => instance.put(`${Config.AMBULANCE_LIST}${id}/`, data),
    deleteAmbulanceData: ({ id }) => {
      return instance.delete(`${Config.AMBULANCE_LIST}${id}/`)
      //console.log(id)
    },

    //booking
    getBookingList: () => instance.get(Config.BOOKING_LIST),
    addBookingList: (data) => instance.post(`${Config.BOOKING_LIST}?is_added_by_admin=true`, data),
    bookingAppointment: (data) => instance.post(Config.BOOKING_LIST, data),
    updateBookingList: ({ id, ...data }) => instance.put(`${Config.BOOKING_LIST}${id}`, data),
    deleteBookingList: (data) =>
      instance.post(`${Config.BOOKING_LIST}super-admin/cancel-booking/`, data),
    getBookingDetails: (id) => instance.get(`${Config.BOOKING_LIST}${id}/`),

    //appointment-duration
    appointmentDurationListApi: () => instance.get(Config.APPOINTMENT_DURATION_LIST),

    //appointment status
    appointmentStatusListApi: () => instance.get(Config.APPOINTMENT_STATUS_LIST),

    //ambulance-type
    ambulanceTypeListApi: () => instance.get(Config.AMBULANCE_TYPE_LIST),
    //ambulance-facility
    ambulanceFacilitiesListApi: () => instance.get(Config.AMBULANCE_FACILITIES_LIST),

    //city
    //cityListApi: (stateId) => instance.get(`${Config.CITY_LIST}${stateId}`),
    cityListApi: (data) => {
      let url = Config.CITY_LIST
      let queryString = ''

      // Check if data is present
      if (data) {
        // Check if data is a number or a string representing a number
        if (typeof data === 'number' || (typeof data === 'string' && !isNaN(data))) {
          // Append the numeric ID to the URL
          url += `${data}`
        } else if (typeof data === 'object' && data !== null) {
          // Destructure data if it's an object
          const { page, pageSize, urlAddOn } = data

          // Add page parameter if it exists and is not empty
          if (page !== undefined && page !== '') {
            queryString += `page=${page}`
          }

          // Add size parameter if it exists and is not empty
          if (pageSize !== undefined && pageSize !== '') {
            if (queryString) {
              queryString += '&' // Append '&' if there's already a query string
            }
            queryString += `size=${pageSize}`
          }

          // Format urlAddOn correctly
          let formattedUrlAddOn = ''
          if (urlAddOn && urlAddOn.trim() !== '') {
            if (queryString) {
              // Ensure urlAddOn starts with '&' if queryString is already present
              formattedUrlAddOn = `&${urlAddOn.startsWith('&') ? urlAddOn.slice(1) : urlAddOn}`
            } else {
              formattedUrlAddOn = urlAddOn
            }
          }

          // Combine queryString with urlAddOn
          queryString += formattedUrlAddOn
        }
      }

      // Construct the final URL with or without query string
      const finalUrl = queryString ? `${url}?${queryString}` : url

      // Make the API call
      return instance.get(finalUrl)
    },

    deleteCity: ({ id }) => instance.delete(`${Config.CITY_LIST}${id}`),
    updateCity: ({ id, ...data }) => instance.put(`${Config.CITY_LIST}${id}`, data),
    addCity: (data) => instance.post(Config.CITY_LIST, data),

    //scan-category
    scanCategoryListApi: () => instance.get(Config.SCAN_CATEGORY_LIST),

    //ima
    getImaBranchData: (data) => instance.get(Config.GET_IMA_BRANCH, data),
  },
  ManagePharmacy: {
    //pharmacy Categories
    subProductTypeListApi: (data) => {
      const { page, pageSize, urlAddOn = '' } = data

      let queryParams = []

      if (page !== undefined) {
        queryParams.push(`page=${page}`)
      }
      if (pageSize !== undefined) {
        queryParams.push(`size=${pageSize}`)
      }
      if (urlAddOn) {
        queryParams.push(urlAddOn)
      }

      const queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : ''
      const url = `${Config.List_SUB_PRODUCT_Type}${queryString}`

      return instance.get(url)
    },
    addPharmacySubType: (data) => instance.post(Config.ADD_PRODUCT_SUB_CATEGORY, data),
    getWearableSizesListApi: () => instance.get(`${Config.WEARABLE_SIZE_LIST}`),

    getProductTypeList: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data

      let queryParams = []

      if (page !== undefined) {
        queryParams.push(`page=${page}`)
      }
      if (pageSize !== undefined) {
        queryParams.push(`size=${pageSize}`)
      }
      if (urlAddOn) {
        queryParams.push(urlAddOn)
      }

      const queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : ''
      const url = `${Config.PRODUCT_TYPE_LIST}${queryString}`

      return instance.get(url)
    },
    getListProductCategoryData: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data

      let queryParams = []

      if (page !== undefined) {
        queryParams.push(`page=${page}`)
      }
      if (pageSize !== undefined) {
        queryParams.push(`size=${pageSize}`)
      }
      if (urlAddOn) {
        queryParams.push(urlAddOn)
      }

      const queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : ''
      const url = `${Config.LIST_PRODUCT_CATEGORY}${queryString}`

      return instance.get(url)
    },

    addProductTypeList: (data) => instance.post(Config.ADD_PRODUCT_TYPE, data),
    addProductByExcel: ({ params, formDataToSubmit }) => {
      const url = `${Config.ADD_PRODUCT_BY_EXCEL}?state_id=${params.state_id}&city_id=${params.city_id}&pharmacy_id=${params.pharmacy_id}`
      return multiPartInstance.post(url, formDataToSubmit, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    },
    addPharmacyByExcel: ({ params, formDataToSubmit }) => {
      // Construct the base URL with state_id and city_id
      let url = `${Config.ADD_PHARMACY_BY_EXCEL}?state_id=${params.state_id}&city_id=${params.city_id}`

      // Conditionally add taluk_id to the URL if it is not null or empty
      if (params.taluk_id) {
        url += `&taluk_id=${params.taluk_id}`
      }

      // Send the POST request with the multipart form data
      return multiPartInstance.post(url, formDataToSubmit, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    },

    updateProductTypeList: ({ id, ...data }) =>
      instance.put(`${Config.UPDATE_PRODUCT_TYPE}${id}/`, data),
    deleteProductTypeList: ({ id }) => instance.delete(`${Config.DELETE_PRODUCT_TYPE}${id}/`),
    getDrugCompositionList: (data) => {
      let last = data?.page || data?.pageSize ? `page=${data.page}&size=${data.pageSize}` : ''
      return instance.get(`${Config.LIST_DRUG_COMPOSITION}?${last}`)
    },
    addDrugComposition: (data) => instance.post(Config.ADD_DRUG_COMPOSITION, data),
    updateSubTypeProductData: ({ id, ...data }) =>
      instance.put(`${Config.UPDATE_SUB_CATEGORY_DATA}${id}/`, data),
    updateDrugComposition: ({ id, ...data }) =>
      instance.put(`${Config.UPDATE_DRUG_COMPOSITION}${id}/`, data),
    deleteDrugCompositions: ({ id }) => instance.delete(`${Config.DELETE_DRUG_COMPOSITION}${id}/`),
    getListComplaintCategoriesData: (data) => instance.get(`${Config.LIST_COMPLAINT_CATEGORY}`),
    getListSuggestionsCategoriesData: (data) => instance.get(`${Config.LIST_SUGGESTIONS_CATEGORY}`),

    getProductTypeDetails: (data) =>
      instance.get(`${Config.PRODUCT_TYPE_LIST}?product_type_id=${data.id}`),
    getProductCategoryDetails: (data) =>
      instance.get(`${Config.LIST_PRODUCT_CATEGORY}?product_category_id=${data.id}`),
    getProductSubCategoryDetails: (data) =>
      instance.get(`${Config.List_SUB_PRODUCT_Type}?product_sub_category_id=${data.id}`),
    addProductCategoryData: (data) => instance.post(Config.ADD_PRODUCT_CATEGORY, data),
    updateProductCategoryData: ({ id, ...data }) =>
      instance.put(`${Config.UPDATE_PRODUCT_CATEGORY}${id}/`, data),
    deleteProductCategoryData: ({ id }) =>
      instance.delete(`${Config.DELETE_PRODUCT_CATEGORY}${id}/`),
    deleteProductSubType: (props) =>
      instance.delete(`${Config.DELETE_PRODUCT_SUB_TYPE}${props.id}/`),
    addProduct: (data) => instance.post(Config.ADD_PRODUCT, data),
    getListProduct: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data

      let queryParams = []

      if (page !== undefined) {
        queryParams.push(`page=${page}`)
      }
      if (pageSize !== undefined) {
        queryParams.push(`size=${pageSize}`)
      }
      if (urlAddOn) {
        queryParams.push(urlAddOn)
      }

      const queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : ''
      const url = `${Config.LIST_PRODUCT}${queryString}`

      return instance.get(url)
    },
    getListProductDetails: ({ id }) =>
      instance.get(`${Config.LIST_PRODUCT_DETAILS}?product_id${id}`),
    getOrderPharmacyList: (data) => {
      let last = `page=${data?.page}&size=${data?.pageSize}${data?.urlAddOn || ''}`
      return instance.get(`${Config.LIST_ORDER_MEDICINE}?${last}`)
    },
    getEachPharmacyOrderList: (data) => {
      return instance.get(`${Config.LIST_ORDER_MEDICINE}?order_id=${data}`)
    },
    getProductDeatils: (data) => {
      return instance.get(`${Config.ADMIN_PRODUCT_DEATILS}?product_id=${data}`)
    },
    getPharmacyDetailsList: () => instance.get(`${Config.PHARMACY_DETAILS}`),

    getallProductList: (data) => {
      return instance.get(`${Config.LIST_PRODUCT}?return_all=true&${data}`)
    },
    updateProduct: ({ id, ...data }) => instance.put(`${Config.UPDATE_PRODUCT}${id}`, data),
    productStatusChange: (data) =>
      instance.patch(`${Config.PRODUCT_STATUS_CHANGE}${data?.id}/?activate=${data.newStatus}`),
    getListMedicineData: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data

      let queryParams = []

      if (page !== undefined) {
        queryParams.push(`page=${page}`)
      }
      if (pageSize !== undefined) {
        queryParams.push(`size=${pageSize}`)
      }
      if (urlAddOn) {
        queryParams.push(urlAddOn)
      }

      const queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : ''
      const url = `${Config.LIST_MEDICINE}${queryString}`

      return instance.get(url)
    },
    addMedicineProduct: (data) => instance.post(Config.ADD_MEDICINE_PRODUCT, data),
    getMedicineDetails: ({ id }) => instance.get(`${Config.DISPLAY_MEDICINE_DETAILS}${id}/`),
  },

  cmsApi: {
    addPages: (data) => instance.post(Config.CMS_VIEW, data),
    getPages: (data) => {
      let last = data?.page || data?.pageSize ? `page=${data?.page}&size=${data?.pageSize}` : ''
      return instance.get(`${Config.CMS_VIEW}?${last}`)
    },
    editPages: ({ id, ...data }) => instance.put(`${Config.CMS_VIEW}${id}`, data),
    deletePages: (page_id) => instance.delete(`${Config.CMS_VIEW}${page_id}`),
    pageDetails: (page_name) => instance.get(`${Config.CMS_VIEW}${page_name}`),
  },
}
